import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { LogoLink } from '../../shared/LogoLink';
import { HeaderSharedStyles, HeaderWedge } from './HeaderSharedStyles';
export const HeaderWithLeftLogoAndControls = ({ controls, }) => {
    return (_jsxs(Header, { children: [_jsx("div", { children: _jsx(LogoLink, {}) }), controls && (_jsx(HeaderControlsContainer, { children: controls })), _jsx(HeaderWedge, {})] }));
};
const HeaderControlsContainer = styled.div `
    display: flex;
    align-items: center;
    gap: 1rem;
`;
const Header = styled.div `
    ${HeaderSharedStyles}
    align-items: center;
    display: grid;
    gap: 1rem;
    grid-template-columns: 1fr auto;
`;
